import { render, staticRenderFns } from "./specialGoods.vue?vue&type=template&id=586b13bf&scoped=true&"
import script from "./specialGoods.vue?vue&type=script&lang=js&"
export * from "./specialGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586b13bf",
  null
  
)

export default component.exports